import NoteAltIcon from '@mui/icons-material/NoteAlt';
import ContentPasteOffIcon from '@mui/icons-material/ContentPasteOff';
import { get } from 'global/lib/lodash';
import { userHasPermissions } from 'redux/actions/userLogin';

/** Locked assessment icon for editors; null means use the normal assignment icon. */
export const getAssessmentLockIcon = (assessment, me, userBuilderRealm) => {
  if (!get(assessment, 'locked') || !get(me, 'id')) {
    return null;
  }

  const meId = me.id;
  const isEditor = [...get(assessment, 'authors', []), ...get(assessment, 'editors', [])].some((u) => u.id == meId);
  const isAdmin =
    userHasPermissions(['manageAccount']) && get(userBuilderRealm, 'id') == get(assessment, 'vendorId') && get(userBuilderRealm, 'id') == get(assessment, 'clientId');

  if (!isEditor && !isAdmin) {
    return null;
  }

  const canOverride = get(assessment, 'lockedBy', []).some((u) => u.id == meId) || userHasPermissions(['manageAccount']);
  return canOverride ? NoteAltIcon : ContentPasteOffIcon;
};
